import { mediaQueries } from './mediaQueries';
import { colors } from './colors';
import { type } from './type';

export default {
  colors,
  mediaQueries,
  type
};
